import {Injectable} from '@angular/core';
import {App} from '@capacitor/app';
import {Capacitor} from '@capacitor/core';
import {Platform} from '@ionic/angular';
import {isNil} from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class Device {
  private applicationVersion: string | null = null;
  private applicationId: string | null = null;
  constructor(
    private readonly platform: Platform,
  ) {}

  public isApp(): boolean {
    return Capacitor.isNativePlatform();
  }

  public async appVersion(): Promise<string> {

    if (!isNil(this.applicationVersion)) {
      return this.applicationVersion;
    }

    if (!this.isApp()) {
      return '0.0.0';
    }

    const appInfo = await App.getInfo();
    this.applicationVersion = appInfo.version;
    return this.applicationVersion;
  }

  public async appId(): Promise<string> {

    if (!isNil(this.applicationId)) {
      return this.applicationId;
    }

    if (!this.isApp()) {
      return 'navigator-finizens-app';
    }

    const appInfo = await App.getInfo();
    this.applicationId = appInfo.id;
    return this.applicationId;
  }

  public isIosApp(): boolean {
    return this.platform.is('ios');
  }

  public isAndroidApp(): boolean {
    return this.platform.is('android');
  }

  public isMobile(): boolean {
    return this.platform.is('mobile');
  }

  public isMobileBrowser(): boolean {
    return this.platform.is('mobileweb');
  }
}
